import angular from 'angular';
import wageAdvanceCardComponent from './wageAdvanceCard.component';

let wageAdvanceCardModule = angular.module('wageAdvanceCard', [])

  .component('wageAdvanceCard', wageAdvanceCardComponent)

  .name;

export default wageAdvanceCardModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceList/wageAdvanceCard/wageAdvanceCard.js